import React from 'react';
import { Button } from '../ui/button';
import { Building2 } from 'lucide-react';

const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export const OwnerEarningsCard = ({ owner, bank, linkBank }) => {
  if (!owner) return null;
  const e = owner.earnings || {};
  return (
    <div className="p-5 rounded-xl bg-[#6366F1]/10 border border-[#6366F1]/30 space-y-3" data-testid="owner-live-earnings" data-sb-live>
      <div className="flex items-center gap-2 text-white font-semibold"><Building2 className="w-5 h-5 text-[#6366F1]" /> {owner.name}: real earnings</div>
      <div className="grid grid-cols-3 gap-2 text-center">
        <div><p className="text-xs text-gray-500">Available</p><p className="text-white font-bold" data-testid="owner-live-available">{money(e.available)}</p></div>
        <div><p className="text-xs text-gray-500">Total earned</p><p className="text-white font-bold">{money(e.total)}</p></div>
        <div><p className="text-xs text-gray-500">Paid out</p><p className="text-white font-bold">{money(e.paid_out)}</p></div>
      </div>
      <p className="text-xs text-gray-400">Paid automatically to your bank through Stripe once you have $20 or more (35% cash-out fee). You also get 25% of the fees Sraivest earns from your business.</p>
      {!bank?.transfers_active && (
        <Button onClick={linkBank} className="btn-primary w-full" data-testid="owner-link-bank-btn">
          {bank ? 'Finish payout setup with Stripe' : 'Set up payouts with Stripe'}
        </Button>
      )}
    </div>
  );
};
